import React from 'react';

const clients = [
  {
    id: 1,
    name: "TXTImpact",
    logo: "https://customer-assets.emergentagent.com/job_growth-marketing-hub-1/artifacts/1z9o8ds1_rfm03oxb8lt1a2o4.png"
  },
  {
    id: 2,
    name: "Reuse Technology Group",
    logo: "https://customer-assets.emergentagent.com/job_growth-marketing-hub-1/artifacts/wpbgqsl7_reusetr.avif"
  },
  {
    id: 3,
    name: "Wire2Air",
    logo: null
  },
  {
    id: 4,
    name: "Opteamix LLC",
    logo: null
  },
  {
    id: 5,
    name: "Mendu Herbs",
    logo: null
  },
  {
    id: 6,
    name: "Maxium Media",
    logo: null
  }
];

const Clients = () => {
  return (
    <section id="clients" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold tracking-widest text-gray-500 uppercase mb-4 block">
            Trusted By
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Clients Served</h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Proud to have worked with leading brands and innovative companies
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 items-center justify-items-center">
          {clients.map((client) => (
            <div
              key={client.id}
              data-testid={`client-${client.id}`}
              className="group flex items-center justify-center p-6 bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 w-full h-28"
            >
              {client.logo ? (
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-h-16 max-w-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300"
                />
              ) : (
                <span className="text-lg font-semibold text-gray-600 group-hover:text-gray-900 transition-colors duration-300 text-center">
                  {client.name}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
